<script>
import routes_mixin from "../../mixins/routes_mixin";
import RouterLinkTo from "../small_components/RouterLinkTo.vue";
import DefaultInput from "../small_components/DefaultInput.vue";
import BadgeBlock from "../slots/BadgeBlock.vue";
import EditIcon from "../icons/EditIcon.vue";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../store/modules/notifiocation";
import {mapActions} from "vuex";
import DefaultTitle from "../small_components/DefaultTitle.vue";
import {axiosArticles, axiosCompanyEquipment} from "../../helpers/axios_requests";
import TextareaEditor from "../small_components/TextareaEditor.vue";
import DefaultSelect from "../small_components/DefaultSelect.vue";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../small_components/DefaultButton.vue";
import { FORMAT_ERROR_MESSAGE } from '../../helpers/validation_error_message';
import {NEW_ARTICLE_CATEGORY, NEW_COMPANY_EQUIPMENT} from "../../helpers/new_objects";
import DefaultBox from "../slots/DefaultBox";
import Switcher from "../small_components/Switcher.vue";
import {ROUTES_NAMES} from "../../router";

export default {
  name: 'CompanyEquipmentView',
  components: {
    Switcher,
    DefaultButton,
    ValidationObserver,
    DefaultSelect, TextareaEditor, DefaultTitle, EditIcon, BadgeBlock, DefaultInput, RouterLinkTo, DefaultBox},
  mixins: [routes_mixin],

  data() {
    return {
      getUserRoleIsAdmin: true,
      new_equipment: false,
      loading: true,
      equipment: []
    }
  },

  created() {
    this.loading = false;
    this.fetchEquipment(this.get_id())
  },

  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.equipment = data || []
    },

    fetchEquipment(id) {
      if (!id) {
        this.$set(this, 'equipment', NEW_COMPANY_EQUIPMENT())
        this.$set(this, 'new_equipment', true)
        return
      }
      this.loading = true
      axiosCompanyEquipment.get(id)
          .then(r => {
            this.fillData(r.data.item)
          })
          .finally(() => {
            this.loading = false
          })
    },

    changeIdentifier(value) {
      this.equipment.identifier = value.checked
    },

    createUpdate() {
      axiosCompanyEquipment.createUpdate(this.equipment)
          .then((r) => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
          }).catch((r) => {
        console.log(r)
      }).finally(() => {
        this.loading = false
        if (this.new_equipment) {
          this.$router.push({name: ROUTES_NAMES.company_equipments})
        }
      })
    },

    get_id() {
      return Number(this.$route.params.id)
    },
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{ $t('articles.article_info') }}
      </default-title>
      <default-box class="position-relative"
                   :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{ $t('equipment.equipment') }} {{ equipment.title }}</h5>
              <div class="card-body">
                <ValidationObserver v-slot="{ invalid, passes }" ref="form">
                  <form class="row mt-20"
                        @submit.prevent="passes(createUpdate)">
                    <div class="col-md-12 col-12 mb-10">
                      <default-input
                          :label="$t('tables.title')"
                          v-model="equipment.title"
                      />
                    </div>
                    <div class="col-md-12 col-12 mb-10">
                      <switcher
                          :placeholder="$t('equipment.identifier')"
                          :checked="equipment.identifier"
                          @change="changeIdentifier"
                      />
                    </div>
                    <div class="text-end mt-20 sticky-bottom">
                      <default-button
                          button_large
                          type="submit">
                        {{ $t('inputs.save') }}
                      </default-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>
</template>
